/**
 * SEO Utilities
 * Manages page meta tags, JSON-LD structured data, and canonical URLs.
 */

export interface PageMeta {
  title: string;
  description: string;
  url?: string;
  image?: string;
  type?: string;
}

export function setPageMeta(config: PageMeta): void {
  document.title = config.title;

  setMeta('description', config.description);
  setMetaProperty('og:title', config.title);
  setMetaProperty('og:description', config.description);
  setMetaProperty('og:url', config.url || window.location.href);
  setMetaProperty('og:type', config.type || 'website');
  if (config.image) setMetaProperty('og:image', config.image);

  // Twitter card
  setMeta('twitter:title', config.title);
  setMeta('twitter:description', config.description);
}

export function setJsonLd(data: object): void {
  // Remove existing SEO JSON-LD
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function setCanonical(url: string): void {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = url;
}

function setMeta(name: string, content: string): void {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}

function setMetaProperty(property: string, content: string): void {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.content = content;
}
